<template>
  <el-container
    class="parent"
    v-loading="loading"
    element-loading-text="正在生成打印内容"
    element-loading-spinner="el-icon-loading"
  >
    <!-- Web打印服务CLodop未安装启动，点击这里<a href='../../../../public/ces123.zip' download='ces123.zip' >下载执行安装</a>
   <br>（若此前已安装过，可<a href='CLodop.protocol:setup' target='_self'>点这里直接再次启动</a> -->
    <el-aside width="350px" class="containerside">
      <div class="flex_between_nowrap">
        <span class="title_before side_title">打印模板</span>
        <el-button
          @click="add_print"
          type="text"
          class="then_color font14"
          icon="iconfont icon-add"
          >新建模板</el-button
        >
      </div>
      <div class="side_min">
        <el-empty description="" v-if="!templateList.length"></el-empty>

        <ul
          v-if="templateList.length"
          style="max-height: 710px;overflow-y: auto;"
          class="user_list"
        >
          <li
            @click.stop="edit_role(item, index, false)"
            v-for="(item, index) in templateList"
            :class="index == current_index ? 'user_active' : ''"
            :key="index"
          >
            <div class="tempNamePrint">
              <span>
                <i
                  class="iconfont icon-user addColor"
                  style="font-size:20px;"
                ></i
              ></span>
              <span class="tempName"
                >{{ item.temp_name
                }}<span
                  >({{
                    item.childrenWidth + "mm*" + item.childrenHeight + "mm"
                  }})</span
                ></span
              >
            </div>
            <div>
              <i
                @click.stop="edit_role(item, index, true)"
                class="iconfont icon-xiugai then_color font16"
              ></i>
              <i
                class="el-icon-delete"
                @click.stop="
                  $axiosDelete(
                    '/pc/print/delTemplate',
                    { id: item.id },
                    get_template,
                    '',
                    false
                  )
                "
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </el-aside>
    <el-main class="min">
      <div style="margin-bottom:20px">
        <span class="title_before " style="padding-left:24px">设置/预览</span>
        <span style="margin-left:16px">
          {{
            this.print_config.temp_name
              ? this.print_config.temp_name
              : "未命名模板"
          }}
        </span>
      </div>
      <div class="flex_end">
        <el-button size="small" type="submit" @click="showdemo"
          >查看设计</el-button
        >
        <el-button size="small" type="submit" @click="drawer = !drawer"
          >标签配置</el-button
        >
      </div>
      <!-- 卷式打印页面 -->
      <div class="print_view">
        <div
          :style="{
            width: print_config.paperWidth + 'mm',
            height: print_config.paperHeight + 'mm',
            background: '#fff',
          }"
        >
          <ul
            v-for="(row, r_index) in print_config.rowNumber"
            :key="r_index"
            :class="
              print_config.columnNum > 1 ? 'p_ulTable' : 'p_ulTable_column1'
            "
          >
            <li
              :class="{ li_border: print_config.columnspacing }"
              :style="{
                flexShrink: 0,
                width: print_config.childrenWidth + 'mm',
                height: print_config.childrenHeight + 'mm',
                marginLeft:
                  c_index == 0 ? 0 : print_config.columnspacing + 'mm',
              }"
              v-for="(col, c_index) in print_config.columnNum"
              :key="c_index"
            >
              <div class="td_content">
                <div
                  :style="{
                    width: print_config[model + 'Config'].width + 'mm',
                    color: print_config[model + 'Config'].fontColor||'#333',
                    overflow: 'hidden',
                    border: `1px dashed ${colorList[m_index]}`,
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',

                    height: print_config[model + 'Config'].height + 'mm',
                    fontWeight: print_config[model + 'Config'].isBold
                      ? 'bold'
                      : 'normal',
                    fontSize: print_config[model + 'Config'].fontSize + 'pt',
                    top: print_config[model + 'Config'].top + 'mm',
                    left: print_config[model + 'Config'].left + 'mm',
                  }"
                  v-for="(model, m_index) in print_config.showtext"
                  :key="m_index"
                >
                  {{ checkBoxGroup[model] }}
                </div>
                <div
                  :style="{
                    width: print_config['borCodeConfig'].width + 'mm',
                    color: '#333',
                    overflow: 'hidden',
                    border: `1px dashed ${colorList[colorList.length - 2]}`,
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',
                    lineHeight: print_config['borCodeConfig'].height + 'mm',

                    textAlign: 'center',
                    height: print_config['borCodeConfig'].height + 'mm',
                    top: print_config['borCodeConfig'].top + 'mm',
                    left: print_config['borCodeConfig'].left + 'mm',
                  }"
                >
                  条码-二维码区域
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 平铺页面 -->
    </el-main>
    <el-drawer
      title="标签设置"
      append-to-body
      size="580px"
      class="print_drawer"
      :direction="direction"
      :modal="false"
      :visible.sync="drawer"
      :destroy-on-close="true"
    >
      <el-collapse v-model="collapse_activeNames">
        <el-collapse-item title="纸张-基础配置" name="1">
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>模板名称</span>
              <el-input
                size="small"
                v-model.trim="print_config['temp_name']"
              ></el-input>
            </div>
            <div>
              <span>
                纸张宽度(mm)
              </span>
              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                v-number_input="2"
                size="small"
                v-model.number="print_config['paperWidth']"
              ></el-input-number>
            </div>
            <div>
              <span>纸张高度(mm)</span>
              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config['paperHeight']"
              ></el-input-number>
            </div>
            <div>
              <span>打印方式</span>
              <el-select
                size="small"
                style="width:100%"
                @change="printTypeChange"
                v-model="print_config['printType']"
              >
                <el-option label="卷式" value="rollType"></el-option>
                <el-option label="平铺" value="tile"></el-option>
              </el-select>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="标签设置-基础设置" name="2">
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div class="">
              <span>列宽度(mm)</span>
              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                @change="globalChange(print_config['childrenWidth'], 'width')"
                v-model.number="print_config['childrenWidth']"
              >
                <i slot="suffix">mm</i>
              </el-input-number>
            </div>
            <div class="">
              <span>列高度(mm)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                :controls="false"
                :precision="2"
                v-model.number="print_config['childrenHeight']"
              >
                <i slot="suffix">mm</i>
              </el-input-number>
            </div>

            <div class="">
              <span>每行列数(列)</span>
              <el-input-number
                :min="1"
                style="width:100%"
                :precision="0"
                :controls="false"
                size="small"
                v-model.number="print_config['columnNum']"
              ></el-input-number>
            </div>
            <div class="">
              <span>列间距(mm)</span>
              <el-input-number
                :min="0"
                style="width:100%"
                :precision="0"
                :controls="false"
                size="small"
                v-model.number="print_config['columnspacing']"
              ></el-input-number>
            </div>
          </div>
          <div class="print_default" style="padding-bottom:0px">
            <div v-if="print_config.printType == 'tile'">
              <span>打印行数</span>
              <el-input-number
                :min="0"
                style="width:100%"
                :precision="0"
                :controls="false"
                size="small"
                v-model.number="print_config['rowNumber']"
              ></el-input-number>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="全局设置-内容设置" name="4">
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>宽度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                @blur="globalChange(print_global['width'], 'width')"
                :controls="false"
                size="small"
                v-model.number="print_global['width']"
              >
              </el-input-number>
            </div>
            <div>
              <span>高度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                @blur="globalChange(print_global['height'], 'height')"
                v-model.number="print_global['height']"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离顶部(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                @blur="globalChange(print_global['top'], 'top')"
                size="small"
                v-model.number="print_global['top']"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离左侧(mm)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                @blur="globalChange(print_global['left'], 'left')"
                v-model.number="print_global['left']"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
          </div>
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>字体大小(pt)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                @blur="globalChange(print_global['fontSize'], 'fontSize')"
                :precision="0"
                :controls="false"
                v-model.number="print_global['fontSize']"
              >
              </el-input-number>
            </div>
            <div>
              <span>是否加粗</span>
              <el-select
                v-model="print_global['isBold']"
                size="small"
                style="width:100%"
                @change="globalChange(print_global['isBold'], 'isBold')"
              >
                <el-option label="加粗" :value="true"> </el-option>
                <el-option label="正常" :value="false"> </el-option>
              </el-select>
            </div>
            <div></div>
            <div></div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="属性显示选择" name="3">
          <el-checkbox-group
            v-model="print_config.showtext"
            @change="showtextChange"
            style="margin-top:20px;padding:0px 30px"
          >
            <el-col :span="8" v-for="(value, key) in checkBoxGroup" :key="key">
              <el-checkbox :label="key">{{ value }}</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-collapse-item>

        <el-collapse-item
          :title="checkBoxGroupLabel(checkBoxGroup[item]) + '-内容设置'"
          v-for="(item, i_index) in print_config.showtext"
          :key="i_index"
          :name="item"
        >
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>宽度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config[item + 'Config'].width"
              >
              </el-input-number>
            </div>
            <div>
              <span>高度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config[item + 'Config'].height"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离顶部(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config[item + 'Config'].top"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离左侧(mm)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                v-model.number="print_config[item + 'Config'].left"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
          </div>
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>字体大小(pt)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                :precision="0"
                :controls="false"
                v-model.number="print_config[item + 'Config'].fontSize"
              >
              </el-input-number>
            </div>
            <div>
              <span>是否加粗</span>
              <el-select
                v-model="print_config[item + 'Config'].isBold"
                size="small"
                style="width:100%"
              >
                <el-option label="加粗" :value="true"> </el-option>
                <el-option label="正常" :value="false"> </el-option>
              </el-select>
            </div>
            <div>
              <span>字体颜色</span>
              <el-color-picker
              class="colorPicker"
              :predefine="['#333']"
                v-model="print_config[item + 'Config'].fontColor"
              ></el-color-picker>
            </div>
            <div></div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="条码/二维码-内容设置" name="borCode">
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>宽度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config['borCodeConfig'].width"
              >
              </el-input-number>
            </div>
            <div>
              <span>高度(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config['borCodeConfig'].height"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离顶部(mm)</span>

              <el-input-number
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                size="small"
                v-model.number="print_config['borCodeConfig'].top"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
            <div>
              <span>距离左侧(mm)</span>
              <el-input-number
                size="small"
                :min="0"
                style="width:100%"
                :precision="2"
                :controls="false"
                v-model.number="print_config['borCodeConfig'].left"
              >
                <i slot="suffix">选填</i>
              </el-input-number>
            </div>
          </div>
          <div
            class="print_default"
            style="padding-top:10px;padding-bottom:0px"
          >
            <div>
              <span>打印类型(mm)</span>
              <el-select
                v-model="print_config['borCodeConfig'].codeType"
                size="small"
                style="width:100%"
              >
                <el-option label="条码" value="128B"> </el-option>
                <el-option label="二维码" value="QRCode"> </el-option>
              </el-select>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="drawer_submit">
        <el-button size="small" type="submit" @click="submit"
          >保存模板</el-button
        >
      </div>
    </el-drawer>
  </el-container>
</template>
<script>
import golop from "@/utils/lodop";

export default {
  name: "",

  data() {
    return {
      colorList: [
        "#b99bff",
        "#fe8b86",
        "#45bbff",
        "#0068dd",
        "#00fcff",
        "#9ae3b7",
        "#06b34b",
        "#bed563",
        "#ccff00",
        "#ff7474",
        "#ff7e00",
        "#b99bff",
        "#fe8b86",
        "#45bbff",
        "#0068dd",
        "#00fcff",
        "#9ae3b7",
        "#06b34b",
        "#bed563",
        "#ccff00",
        "#ff7474",
        "#ff7e00",
        "#b99bff",
        "#fe8b86",
        "#45bbff",
        "#0068dd",
        "#00fcff",
        "#9ae3b7",
        "#06b34b",
        "#bed563",
        "#ccff00",
        "#ff7474",
        "#ff7e00",
      ],
      loading: false,
      editFlag: true,

      direction: "ltr",
      collapse_activeNames: ["1", "2", "3", "4", "5", "6", "borCode"],
      drawer: false,

      checkBoxGroup: {},

      /* 打印设置 start
        isTile //纸张打印方式  true为平铺打印  false为卷式打印
        paperwidth //纸张宽度
        paperheight //纸张高度只有为  isTile：false才生效，

      */

      templateList: [],
      current_index: null,
      print_global: {
        width: 60,
        height: 5,
        top: 0,
        left: 0,
        fontSize: 10,
        isBold: true,
      },
      default_print_global: {},
      default_print_config: {},
      print_config: {
        showtext: [],
        rowNumber: 1,
        printType: "rollType",
        columnspacing: 0,
        repeatNum: 1,
        borCodeConfig: {
          width: 60,
          height: 5,
          top: 0,
          left: 0,
          codeType: "128B",
        },
        checkList: [] /* 代表的每个数据 */,
        pagenumber: 50,
        columnNum: 1, //每行列数
        temp_name: "",
        childrenWidth: 60,
        childrenHeight: 40,
        paperWidth: 60,
        paperHeight: 40,
      },

      /* 打印设置 end */
    };
  },
  mounted() {
    this.$codeImg()
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {});
    console.log();
  },
  watch: {
    "print_config.showtext"(newValue, oldValue) {
      if (this.editFlag) {
        if (newValue.length > oldValue.length) {
          /* 选中 */

          for (let i = 0; i < newValue.length; i++) {
            if (!this.print_config[newValue[i] + "Config"]) {
              this.collapse_activeNames.push(newValue[i]);
              this.$set(
                this.print_config,
                newValue[i] + "Config",
                new Object()
              );

              for (let key in this.print_global) {
                this.print_config[newValue[i] + "Config"][
                  key
                ] = this.print_global[key];
              }

              this.$set(
                this.print_config[newValue[i] + "Config"],
                "top",
                i == 0
                  ? 0
                  : this.print_config[newValue[i - 1] + "Config"].top +
                      this.print_config[newValue[i - 1] + "Config"].height
              );
              if (i == newValue.length - 1) {
                this.$set(
                  this.print_config["borCodeConfig"],
                  "top",
                  this.print_config[newValue[i] + "Config"].top +
                    this.print_config[newValue[i] + "Config"].height
                );
              }
            }
          }
        } else {
          /* 取消选中,找出取消的那个 */
          for (let i = 0; i < oldValue.length; i++) {
            if (newValue[i] !== oldValue[i]) {
              for (let k = 0; k < this.collapse_activeNames.length; k++) {
                if (this.collapse_activeNames[k] == oldValue[i]) {
                  this.collapse_activeNames.splice(k, 1);
                  break;
                }
              }
              // if (i == newValue.length) {
              //   this.$set(
              //     this.print_config["borCodeConfig"],
              //     "top",

              //     this.print_config[newValue[i - 1] + "Config"].top +
              //       this.print_config[newValue[i - 1] + "Config"].height
              //   );
              // }

              for (let j = i; j < newValue.length; j++) {
                this.$set(
                  this.print_config[newValue[j] + "Config"],
                  "top",
                  i == 0
                    ? 5
                    : this.print_config[newValue[j - 1] + "Config"].top +
                        this.print_config[newValue[j - 1] + "Config"].height
                );
              }
              delete this.print_config[oldValue[i] + "Config"];
              break;
            }
          }

          if (newValue.length) {
            this.$set(
              this.print_config["borCodeConfig"],
              "top",

              this.print_config[newValue[newValue.length - 1] + "Config"].top +
                this.print_config[newValue[newValue.length - 1] + "Config"]
                  .height
            );
          } else {
            this.$set(
              this.print_config["borCodeConfig"],
              "top",

              this.print_global.top
            );
          }
        }
      }
    },
  },
  methods: {
    childrenWidthChange(data) {
      for (let i = 0; i < this.print_config.showtext.length; i++) {
        this.$set(
          this.print_config[this.print_config.showtext[i] + "Config"],
          `width`,
          data
        );
      }
      this.$set(this.print_config.borCodeConfig, "width", data);
    },
    checkBoxGroupLabel(label) {
      if ("borCode" == label) {
        label = "条码/二维码区域";
      }
      if (label.indexOf(":") !== -1) {
        label = label.substr(0, label.indexOf(":"));
      }
      return label;
    },
    printTypeChange(data) {
      if (data == "rollType") {
        this.$set(this.print_config, "rowNumber", 1);
      }
    },
    /* 打印设置 start */
    /* 纸张类型切换  false為平鋪 true 為捲式*/

    showdemo() {
      this.loading = true;
      let w;
      let l = golop();
      if(!l){
      this.loading = false;
        
      }
      l.PRINT_INIT("");

      l.SET_PRINT_PAGESIZE(
        0,
        this.print_config.paperWidth + "mm",
        this.print_config.paperHeight + "mm",
        "CreateCustomPage"
      );
      //  printType: "rollType",
      if (this.print_config.printType == "tile") {
        for (let r = 0; r < this.print_config.rowNumber; r++) {
          for (let c = 0; c < this.print_config.columnNum; c++) {
            for (let m = 0; m < this.print_config.showtext.length; m++) {
              l.SET_PRINT_STYLE("FontColor", this.print_config[this.print_config.showtext[m] + "Config"]
                  .fontColor); //给前面的那个文本加粗。
              l.SET_PRINT_STYLE(
                "FontSize",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .fontSize
              );
              l.SET_PRINT_STYLE(
                "Bold",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .isBold
                  ? 1
                  : 0
              ); //给前面的那个文本加粗。
      
              l.ADD_PRINT_TEXT(
                r == 0
                  ? this.print_config[this.print_config.showtext[m] + "Config"]
                      .top + "mm"
                  : r *
                      (this.print_config.childrenHeight +
                        this.print_config[
                          this.print_config.showtext[m] + "Config"
                        ].top) +
                      "mm",
                c == 0
                  ? this.print_config[this.print_config.showtext[m] + "Config"]
                      .left + "mm"
                  : c *
                      (this.print_config.childrenWidth +
                        this.print_config.columnspacing +
                        this.print_config[
                          this.print_config.showtext[m] + "Config"
                        ].left) +
                      "mm",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .width + "mm",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .height + "mm",

                this.checkBoxGroupLabel(
                  this.checkBoxGroup[this.print_config.showtext[m]]
                )
              );
            }
            w =
              (11 * "abc12345".length + 35) * 0.01639 * 25.4 >
              this.print_config["borCodeConfig"].width -
                this.print_config["borCodeConfig"].left
                ? this.print_config["borCodeConfig"].width -
                  this.print_config["borCodeConfig"].left
                : (11 * "abc12345".length + 35) * 0.01639 * 25.4;
                l.SET_PRINT_STYLE("FontColor",'#000'); //给前面的那个文本加粗。
            l.ADD_PRINT_BARCODE(
              r * this.print_config.childrenHeight +
                this.print_config["borCodeConfig"].top +
                "mm",
              c == 0
                ? this.print_config["borCodeConfig"].left + "mm"
                : c *
                    (this.print_config.childrenWidth +
                      this.print_config["borCodeConfig"].left +
                      this.print_config.columnspacing) +
                    "mm",
              w + "mm",
              // this.print_config.columns_config["assetCode"].width + "mm",
              this.print_config["borCodeConfig"].height + "mm",
              this.print_config["borCodeConfig"].codeType || "128B",

              "abc12345"
            );
          }
        }
      } else {
        for (let r = 0; r < this.print_config.rowNumber; r++) {
          for (let c = 0; c < this.print_config.columnNum; c++) {
            for (let m = 0; m < this.print_config.showtext.length; m++) {
              l.SET_PRINT_STYLE(
                "FontSize",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .fontSize
              );
              l.SET_PRINT_STYLE("FontColor",  this.print_config[this.print_config.showtext[m] + "Config"]
                  .fontColor); //给前面的那个文本加粗。

              l.SET_PRINT_STYLE(
                "Bold",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .isBold
                  ? 1
                  : 0
              ); //给前面的那个文本加粗。
              l.ADD_PRINT_TEXT(
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .top + "mm",
                c == 0
                  ? this.print_config[this.print_config.showtext[m] + "Config"]
                      .left + "mm"
                  : c *
                      (this.print_config.childrenWidth +
                        this.print_config.columnspacing +
                        this.print_config[
                          this.print_config.showtext[m] + "Config"
                        ].left) +
                      "mm",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .width + "mm",
                this.print_config[this.print_config.showtext[m] + "Config"]
                  .height + "mm",

                this.checkBoxGroupLabel(
                  this.checkBoxGroup[this.print_config.showtext[m]]
                )
              );
            }
            w =
              (11 * "abc12345".length + 35) * 0.01639 * 25.4 >
              this.print_config["borCodeConfig"].width -
                this.print_config["borCodeConfig"].left
                ? this.print_config["borCodeConfig"].width -
                  this.print_config["borCodeConfig"].left
                : (11 * "abc12345".length + 35) * 0.01639 * 25.4;
                l.SET_PRINT_STYLE("FontColor",'#000'); //给前面的那个文本加粗。

            l.ADD_PRINT_BARCODE(
              this.print_config["borCodeConfig"].top + "mm",
              c == 0
                ? this.print_config["borCodeConfig"].left + "mm"
                : c *
                    (this.print_config.childrenWidth +
                      this.print_config["borCodeConfig"].left +
                      this.print_config.columnspacing) +
                    "mm",
              w + "mm",
              // this.print_config.columns_config["assetCode"].width + "mm",
              this.print_config["borCodeConfig"].height + "mm",
              this.print_config["borCodeConfig"].codeType || "128B",
              "abc12345"
            );
          }
        }
      }
      l.PREVIEW();
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },

    submit() {
      if (this.print_config.temp_name) {
        this.$requestAxiosForm(
          {
            url: "/pc/print/setTemplate",
            data: this.print_config,
          },
          (data) => {
            this.$success("操作成功!");
            this.drawer = false;
            this.get_template();
          }
        );
      } else {
        this.$success("请输入模板名称", "error");
      }
    },
    add_print() {
      console.log(this.print_config);
      this.editFlag = false;
      this.print_config = JSON.parse(JSON.stringify(this.default_print_config));
      this.print_global = JSON.parse(JSON.stringify(this.default_print_global));
      this.$set(this.print_config, "checkList", []);
      this.drawer = true;
      this.current_index = null;
      setTimeout(() => {
        this.editFlag = true;
      });
    },

    /* 动态配置的change */
    showtextChange(data) {
      console.log(data);
      this.$nextTick(() => {
        let d = JSON.parse(JSON.stringify(this.print_config));
        
        data.forEach((item) => {
          d[item + "Config"].fontColor='#333'

          this.$set(this.print_config, item + "Config", d[item + "Config"]);
        });
      });
    },
    /* 全局设置 */
    globalChange(val, key) {
      if (key == "top") {
        for (let i = 0; i < this.print_config.showtext.length; i++) {
          this.$set(
            this.print_config[this.print_config.showtext[i] + "Config"],
            key,
            i == 0
              ? val
              : this.print_config[this.print_config.showtext[i - 1] + "Config"]
                  .top +
                  this.print_config[
                    this.print_config.showtext[i - 1] + "Config"
                  ].height
          );
        }
        if (this.print_config.showtext.length) {
          this.$set(
            this.print_config.borCodeConfig,
            key,
            this.print_config[
              this.print_config.showtext[
                this.print_config.showtext.length - 1
              ] + "Config"
            ].top +
              this.print_config[
                this.print_config.showtext[
                  this.print_config.showtext.length - 1
                ] + "Config"
              ].height
          );
        } else {
          this.$set(this.print_config.borCodeConfig, key, val);
        }
      }
      if (key == "height") {
        for (let i = 0; i < this.print_config.showtext.length; i++) {
          this.$set(
            this.print_config[this.print_config.showtext[i] + "Config"],
            key,
            val
          );
          this.$set(
            this.print_config[this.print_config.showtext[i] + "Config"],
            "top",
            i == 0
              ? this.print_global.top
              : this.print_config[this.print_config.showtext[i - 1] + "Config"]
                  .top +
                  this.print_config[
                    this.print_config.showtext[i - 1] + "Config"
                  ].height
          );
        }
        this.$set(this.print_config.borCodeConfig, key, val);
        if (this.print_config.showtext.length) {
          this.$set(
            this.print_config.borCodeConfig,
            "top",
            this.print_config[
              this.print_config.showtext[
                this.print_config.showtext.length - 1
              ] + "Config"
            ].top +
              this.print_config[
                this.print_config.showtext[
                  this.print_config.showtext.length - 1
                ] + "Config"
              ].height
          );
        } else {
          this.$set(this.print_config.borCodeConfig, key, val);
        }
      }
      if (key !== "top" && key !== "height") {
        console.log("执行了吗");
        for (let i = 0; i < this.print_config.showtext.length; i++) {
          this.$set(
            this.print_config[this.print_config.showtext[i] + "Config"],
            key,
            val
          );
        }
        this.$set(this.print_config.borCodeConfig, key, val);
        
      }
    },

    /* 打印设置 end */

    init() {
      this.default_print_config = JSON.parse(JSON.stringify(this.print_config));
      this.default_print_global = JSON.parse(JSON.stringify(this.print_global));
      this.$requestAxios(
        {
          url: "/pc/print/getSelect",
          data: {},
        },
        (data) => {
          this.checkBoxGroup = data.data;
        }
      );
      this.get_template();
    },
    get_template() {
      this.$requestAxios(
        {
          url: "/pc/print/getTemplate",
          data: {},
        },
        (data) => {
          this.templateList = data.data;
          if (this.templateList) {
            this.current_index = 0;
            this.print_config = JSON.parse(
              JSON.stringify(this.templateList[0])
            );
          }
          if (data.data.length) {
            this.current_index = 0;
            this.print_config = JSON.parse(JSON.stringify(data.data[0]));
          }
        }
      );
    },
    edit_role(item, index, flag) {
      this.editFlag = false;

      this.print_flag = true;
      this.print_global = JSON.parse(JSON.stringify(this.default_print_global));
      this.print_config = JSON.parse(JSON.stringify(item));
      this.current_index = index;
      this.drawer = flag;
      setTimeout(() => {
        this.editFlag = true;
      });
    },
  },
};
</script>
<style scoped>
ul,
li {
  padding: 0;
  margin: 0;
}
.firstul {
}
.firstul > li {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 43px;
  padding-top: 55px;
}
.firstul > li:first-child {
  padding-top: 20px;
}
.min_foo {
  position: fixed;
  bottom: 22px;
  right: 40px;
  width: 100%;
}
.min_foo > div {
  height: 80px;
}
.childrenul {
  display: flex;
  flex-flow: row wrap;
  margin-left: 28px;
}
.childrenul > li {
  margin-right: 40px;
  margin-top: 20px;
}
.parent {
  height: 100%;
  background-color: #f6f7fc;
}

.side_min {
  padding-left: 20px;
  margin-top: 20px;
  height: 100%;
}
.input_icon {
  margin-bottom: 30px;
}

.user_list,
.user_list li {
  margin: 0;
  padding: 0;
}
.user_list li {
  padding-left: 22px;
  padding-right: 10px;
  background-color: #fff;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.user_list li > div:last-child {
  display: none;
}
.user_list li > div:first-child > span {
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
  color: #333333;
  line-height: 36px;
}
.user_list li:hover {
  background-color: #f3f6fb;
  border-radius: 2px;
}
.user_list li > div:last-child > i:last-child {
  margin-left: 10px;
  opacity: 0.8;
}

.user_list li:hover > div:last-child {
  display: block;
}

.user_active {
  background-color: #f3f6fb !important;
  border-radius: 2px;
}
.user_active > div:last-child {
  display: block !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.iconList > i {
  padding-right: 10px;
}
.working {
  background-color: #d8e6ff;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}
.dimission {
  background-color: #e0e0e0;
  border-radius: 4px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0px;
  color: #7c7c7c;
}

.print_drawer /deep/ .el-collapse-item__header {
  line-height: 50px;
  height: 50px;
  padding-left: 30px;
  user-select: none;
  background-color: #f8f8f8;
}
.print_drawer /deep/ .el-collapse-item__header > i {
  color: #436bff;
  /* height: 50px; */
  /* line-height: 50px; */
}
.colimn_config {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding-left: 30px;
  box-sizing: border-box;
  padding-top: 20px;
  width: 100%;
}

.colimn_config > div.column_children {
  margin-right: 40px;
}
.column_children {
  margin-bottom: 20px;
  width: 130px;
  height: 58px;
  box-sizing: border-box;
}

.print_drawer /deep/ .el-drawer__header {
  font-size: 16px;
  letter-spacing: 0px;
  color: #333333;
  font-weight: bold;
}

.print_row {
  position: relative;
}
.print_column {
  position: absolute;

  background: #fff;
  /* overflow: hidden; */
}
.print_column > div {
  position: absolute;
}
.print_column_item {
  overflow: hidden;
}
.print_column_code {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
  background: darkgray;
  color: #fff;
}
/* .print_column::after {
  content: "";
  width: 1px;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #436bff;
}
.print_column::before {
  content: "";
  width: 1px;
  height: 100%;
  right: 0;
  top: 0;
  z-index: 2;
  position: absolute;
  background: #436bff;
} */
.itemPleft {
  width: 1px;
  position: absolute;
  top: 0;
  z-index: 2;
  background: #436bff;
}
.itemPtop {
  height: 1px;
  position: absolute;
  top: 0;
  z-index: 2;
  background: #436bff;
}
.groupList {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-around;
}
.print_default {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  box-sizing: border-box;
}
.print_default > div {
  width: 120px;
}

.print_default > div > span {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #aeaeae;
  display: inline-block;
  margin-bottom: 10px;
}
.printGlobal {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 30px;
  box-sizing: border-box;
}
.printGlobal > div {
  width: 100px;
  margin-right: 40px;
}

.printGlobal_children > span,
.column_children > span,
.print_default > div > span,
.print_default_children > div > span {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;

  color: #aeaeae;
  display: inline-block;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.tempName {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 180px;
  display: inline-block;
  /* height: 36px; */
  /* line-height: 36px; */
}
.tempNamePrint {
  display: flex;
  flex-flow: row nowrap;
  align-content: center;
  height: 36px;
  justify-content: flex-start;
}
.parent {
  height: 100%;
  background-color: #f6f7fc;
}

.draweritemBox {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 30px;
}
.draweritemBoxwarp {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 30px;
}
.draweritemBoxwarp > div,
.draweritemBox > div {
  margin-top: 25px;
  box-sizing: border-box;
  margin-right: 20px;
  width: 107px;
}
.draweritemBoxwarp > div > span,
.draweritemBox > div > span {
  font-size: 14px;
  width: 100%;
  color: #aeaeae;
  margin-bottom: 12px;
  display: inline-block;
  box-sizing: border-box;
}

.p_ulTable {
  background: #fff;
  /* position: relative; */
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
.p_ulTable > li {
  /* position: absolute; */
  border: 1px dashed #ccc;
  z-index: 2;
}
.print_view {
  width: 100%;
  height: 670px;
  background-color: #f6f7fc;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  padding: 20px;
  box-sizing: border-box;
  margin: 20px 0px;
  overflow: auto;
}
.print_view > div > ul > li {
  border-top: none;
}
.print_view > div > ul:first-child > li {
  border-top: 1px dashed #ccc;
}
.p_ulTable > li {
  border-left: none;
}
.p_ulTable > li:first-child {
  border-left: 1px dashed #ccc;
}
.td_content {
  width: 100%;
  height: 100%;
  position: relative;
}
.td_content > div {
  position: absolute;
}
.li_border {
  border-left: 1px dashed #ccc !important;
}
.td_content:hover .td_content_hover {
  display: block;
}
.td_content_hover {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: none;
}

.td_content_delete {
  width: 100%;
  height: 100%;
  color: #436bff;
  font-size: 18px;
  cursor: pointer;
  background: rgba(204, 204, 204, 0.5);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
.drawer_submit {
  position: absolute;
  top: 15px;
  right: 80px;
}
.p_ulTable_column1 {
  background: #fff;
  /* position: relative; */
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.p_ulTable_column1 > li {
  border: 1px dashed #ccc;
  z-index: 2;
  border-top: none;
}
.p_ulTable_column1 > li:first-child {
  border-top: 1px dashed #ccc;
}
.drawer_submit {
  position: absolute;
  top: 15px;
  right: 80px;
}
</style>
